import moment from 'moment';
import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export async function fetchSubsidiaryDropdown(app, params) {
  const { searchTerm, fields, searchParams, id } = params;
  const dropdown_type = 'subsidiary/dropdown';

  const query = {
    id,
    fields,
    searchTerm,
    searchParams,
    dropdown_type,
  };

  const result = await common.getDropdownList(app, { query });
  const { excluded_subsidiaries } = searchParams || {};
  return result.filter(({ id }) => {
    return (excluded_subsidiaries || []).indexOf(id) === -1;
  });
}

export function deleteSubsidiary(app, params) {
  const { id } = params;
  const docType = DocType.SUBSIDIARY;
  return common.deleteDoc(app, { id, docType });
}

export function saveSubsidiary(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const now = moment.utc();
  let subsidiaryData = {
    doc_type: DocType.SUBSIDIARY,
    name: util.toStringText(data.name),
    active: util.toBoolean(data.active),
    primary_subsidiary: util.toBoolean(data.primary_subsidiary),
    legal_company_name: util.toStringText(data.legal_company_name),
    display_company_name: util.toStringText(data.display_company_name),
    business_company_number: util.toStringText(data.business_company_number),
    currency_id: data.currency_id,
    last_updated: now.format(),
    // last_updated_by: util.toObjectId(user.id),
    last_updated_by: user.id,
    email: util.toStringText(data.email),
    format_date: data.format_date,
    format_time: data.format_time,
    format_number: data.format_number,
    format_negative_number: data.format_negative_number,
    format_negative_number_colour: data.format_negative_number_colour,
    short_name: util.toStringText(data.short_name),
    language_id: data.language_id,
    timezone: util.toStringText(data.timezone),
    parent_id: (data.primary_subsidiary) ? null : data.parent_id,
    default_device_timeout: "",
    address_details: data.address_details,
    contacts: util.toObjectArray(data.contacts),
    company_logo: util.toStringText(data.company_logo),
    company_logo_icon: util.toStringText(data.company_logo_icon),
    custom_fields: data.custom_fields,
  };

  return common.saveDoc(app, {
    source: data,
    doc: subsidiaryData,
    user,
  });

}


export async function fetchSubsidiaryById(app, params) {
  const { id, path } = params;
  const docType = DocType.SUBSIDIARY;
  const doc = await common.getDoc(app, { id, docType }, { assemble_custom_fields: true });
  return util.filterCustomFieldsByViewMode(doc, path);
}


export async function findPrimarySubsidiary(app, params) {
  const path = 'subsidiary/employee'
  const { employeeId } = params;
  if(employeeId){
    return common.getDoc(app, { id: employeeId, docType: path });
  }
}
